module.exports = __webpack_public_path__ + "static/media/nasa-rover.907bf108.jpg";